import { render } from "./TweetPopup.vue?vue&type=template&id=008a9de0"
import script from "./TweetPopup.vue?vue&type=script&lang=js"
export * from "./TweetPopup.vue?vue&type=script&lang=js"

import "./TweetPopup.vue?vue&type=style&index=0&id=008a9de0&lang=scss"
script.render = render

export default script